import script from "./MaintenanceNoticeContent.vue?vue&type=script&setup=true&lang=js"
export * from "./MaintenanceNoticeContent.vue?vue&type=script&setup=true&lang=js"

import "./MaintenanceNoticeContent.vue?vue&type=style&index=0&id=4e89fe5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e89fe5e"]])

export default __exports__